export const scriptSrc = (url: string) =>
  import.meta.env.API_ADAPTER === "us"
    ? `https://proxy.csidetm.com/${url}`
    : url;
